import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { getCurrentUserV2QueryOptions } from '@/services/getCurrentUserV2';
import { userIdAtom } from '@/services/globalState';

export function useSmsNotifySetup() {
  const userId = useAtomValue(userIdAtom);

  const { data: userData } = useQuery(getCurrentUserV2QueryOptions(userId));

  const mobilePhoneSliced = userData?.mobilePhone?.replace('+1', '') || '';

  const hasPhoneNumber = mobilePhoneSliced.length > 0;

  /** "Notify me when ready" delivers the dedicated referencesReady notification —
   * it does NOT ride on newMessage — so this is the flag that decides whether
   * SMS will reach the expert for the reference wizard prompt. */
  const referencesReadySmsEnabled = Boolean(userData?.notificationsPreferences?.referencesReadySms);

  const smsWillReach = hasPhoneNumber && referencesReadySmsEnabled;

  return { smsWillReach, hasPhoneNumber, mobilePhoneSliced, referencesReadySmsEnabled };
}
